/**
 * Tooltip — a short label shown beside a control on hover and focus, for icon-only controls whose name is not on
 * screen (a collapsed rail's icons). Wraps the vendored TailGrids tooltip (`tailgrids/core/tooltip.tsx`, as the
 * collapsed detailed sidebar uses it in `ShellNavItem.tsx`). The child keeps its own `aria-label`; the tooltip is for
 * sighted users. Demo page: /ui-elements/tooltips.
 */
import type { Placement } from '@floating-ui/react';
import type { ReactElement } from 'react';
import { Tooltip as TooltipRoot, TooltipContent, TooltipTrigger } from '../tailgrids/core/tooltip.js';

interface TooltipProps {
  label: string;
  placement?: Placement;
  /** One element that takes a ref (a `Button`, a link). */
  children: ReactElement;
}

export function Tooltip({ label, placement = 'right', children }: TooltipProps) {
  return (
    <TooltipRoot placement={placement}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent>
        <p>{label}</p>
      </TooltipContent>
    </TooltipRoot>
  );
}
